import React, { useContext } from 'react'

export const EnvContext = React.createContext({})
export const EnvProvider = EnvContext.Provider

export const useEnv = () => useContext(EnvContext)
